import { useEffect } from "react";
import { canonicalUrl } from "@/lib/site";

interface SeoProps {
  title: string;
  description: string;
  canonicalPath?: string;
}

// Lightweight per-page SEO: updates document title, meta description, and canonical.
export const Seo: React.FC<SeoProps> = ({
  title,
  description,
  canonicalPath = "/",
}) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (
      attr: "name" | "property",
      key: string,
      content: string,
    ) => {
      let el = document.head.querySelector(
        `meta[${attr}="${key}"]`,
      ) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const href = canonicalUrl(canonicalPath);

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", href);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const links = document.head.querySelectorAll('link[rel="canonical"]');
    if (links.length === 0) {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", href);
      document.head.appendChild(link);
    } else {
      links.forEach((node, index) => {
        if (index === 0) node.setAttribute("href", href);
        else node.remove();
      });
    }

    window.scrollTo({ top: 0, behavior: "auto" });
  }, [title, description, canonicalPath]);

  return null;
};
